import * as api from './api'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { checkTtlDate } from '@/helper'
import { USERS } from '@/constants/localStorage'
import { THREE_HOUR } from '@/constants/time'

export default {
  async loadData ({ commit }, { force = false } = {}) {
    const usersLocal = getLocalData(USERS)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (usersLocal?.updateDate || 0),
      ttlTime: THREE_HOUR
    })

    if (!force && usersLocal && !isNeedUpdate) {
      commit('setData', usersLocal.data)

      return { data: usersLocal.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      commit('setData', data.data)

      setLocalData(USERS, {
        updateDate: Date.now(),
        data: data.data
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.push(data.data)

      commit('setData', newData)

      setLocalData(USERS, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(USERS, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async deactivate ({ commit, state }, id) {
    const { data } = await api.deactivate(id) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item.status = 'deactivated'
        }

        return item
      })

      commit('setData', newData)

      setLocalData(USERS, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async activate ({ commit, state }, id) {
    const { data } = await api.activate(id) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item.status = 'activated'
        }

        return item
      })

      commit('setData', newData)

      setLocalData(USERS, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, payload) {
    const { data } = await api.remove(payload) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({id}) => id !== payload)

      commit('setData', newData)

      setLocalData(USERS, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  }
}